// syncronous, gaan we gebruiken om variabelen te setten
import LEASING_COMPANY_MUTATION_TYPES from './leasing-company.mutation-types';

const LEASING_COMPANY_MUTATIONS = {
  [LEASING_COMPANY_MUTATION_TYPES.SET_ERROR](state, error) {
    state.status.error = error;
  },
  [LEASING_COMPANY_MUTATION_TYPES.APPEND_LEASING_COMPANIES](state, leasingCompanies) {
    state.leasingCompanies = leasingCompanies;
  },
};

export default LEASING_COMPANY_MUTATIONS;
